import type {
  EventHandlerCb,
  ExtendedConstraints,
  CapabilityConfig,
} from '../../../types';
import {
  type ParticipantId,
  type Participant,
  type ParticipantMessage,
  type Message,
  type ParticipantAction,
  type Action,
  type MultiplayerConfig,
  isValidConfig as isValidMultiplayerConfig,
} from '../multiplayer';

export const id = 'multiplayer-room';

export enum Events {
  Joined = 'multiplayer-room:joined',
  Departed = 'multiplayer-room:departed',
  Message = 'multiplayer-room:message',
  ParticipantList = 'multiplayer-room:participant-list',
  RealtimeId = 'multiplayer-room:realtime-id',
}
export enum Actions {
  SendMessage = 'multiplayer-room:send-message',
  SendMessageAll = 'multiplayer-room:send-message-all',
  SendAction = 'multiplayer-room:trigger-action',
  SendActionAll = 'multiplayer-room:trigger-action-all',
  RequestParticipants = 'multiplayer-room:request-participants',
  RequestRealtimeId = 'multiplayer-room:request-realtime-id',
}

export type Config = MultiplayerConfig & {
  type: typeof id;
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;

  eventPayloadTuple:
    | [Events.Joined, Participant[]]
    | [Events.Departed, Participant[]]
    | [Events.Message, ParticipantMessage]
    | [Events.ParticipantList, Participant[]]
    | [Events.RealtimeId, ParticipantId];
  eventHandlerTuple:
    | [Events.Joined, EventHandlerCb<Participant[]>]
    | [Events.Departed, EventHandlerCb<Participant[]>]
    | [Events.Message, EventHandlerCb<ParticipantMessage>]
    | [Events.ParticipantList, EventHandlerCb<Participant[]>]
    | [Events.RealtimeId, EventHandlerCb<ParticipantId>];
  actionPayloadTuple:
    | [Actions.SendMessage, ParticipantMessage]
    | [Actions.SendMessageAll, Message]
    | [Actions.SendAction, ParticipantAction]
    | [Actions.SendActionAll, Action]
    | [Actions.RequestParticipants]
    | [Actions.RequestRealtimeId];
}>;

export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!isValidMultiplayerConfig(config)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
